import "./code_snippet.scss";
import { Text } from "@/elements/text/text";
import classNames from "classnames";
import React from "react";

interface Props {
  title: string;
  small?: boolean;
  accent?: boolean;
}

export function CodeSnippet({
  title,
  small,
  accent,
}: Props): React.ReactElement {
  return (
    <span
      className={classNames("code-snippet", {
        "code-snippet--small": small,
        "code-snippet--accent": accent,
      })}
    >
      <Text
        type={small ? "snippet-body" : "snippet"}
        color={accent ? "accent-default" : "inverted-pairings-default"}
      >
        {title}
      </Text>
    </span>
  );
}
